import PopoverMsg from '@/components/ui/PopoverMsg';
import { copyToClipboard } from '@/utils';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Box, CircularProgress, IconButton, Typography } from '@mui/material';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'next-i18next';
import LeaderboardPanel from './LeaderboardPanel';
import ResultPanel from './ResultPanel';
import { StyledTab, StyledTabs } from './styles';
import { CrashLatestGameItem } from '@/apis/casino/crash';
import { formatGameTime } from '@/utils/time';

interface CrashGameDetailProps {
  detail: CrashLatestGameItem | null;
}

const CrashGameDetail: React.FC<CrashGameDetailProps> = ({ detail }) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleCopy = (content, e) => {
    copyToClipboard(content).then(() => {
      setAnchorEl(e.target.parentNode);
      setTimeout(() => {
        setAnchorEl(null);
      }, 1000);
    });
  };

  const tabs = [
    { value: 'Result', label: 'Result' },
    // { value: 'Leaderboard', label: 'Leaderboard' },
  ];

  const [currentTab, setCurrentTab] = useState<string>('Result');
  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setCurrentTab(newValue);
  };
  const resultSelected = useMemo(() => currentTab === 'Result', [currentTab]);
  if (!detail) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '400px',
        }}
      >
        <CircularProgress></CircularProgress>
      </Box>
    );
  }
  return (
    <>
      <PopoverMsg anchorEl={anchorEl}></PopoverMsg>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography
          variant="h6"
          sx={{ fontWeight: 600, mb: 1, mt: 2 }}
          fontFamily={'Readex Pro'}
        >
          {t('Crash Game')}:{detail.roundId}
          <IconButton
            onClick={(e) => handleCopy(detail.roundId, e)}
            sx={{ verticalAlign: '-3px', ml: 1 }}
          >
            <ContentCopyIcon />
          </IconButton>
        </Typography>
        <Typography sx={{ mb: 3 }}>
          {formatGameTime(detail.startTime)}
        </Typography>
        <StyledTabs value={currentTab} onChange={handleTabChange}>
          {tabs.map((tab) => (
            <StyledTab
              key={tab.value}
              label={tab.label}
              value={tab.value}
            ></StyledTab>
          ))}
        </StyledTabs>
      </Box>
      {resultSelected && <ResultPanel detail={detail}></ResultPanel>}
      {!resultSelected && <LeaderboardPanel detail={detail}></LeaderboardPanel>}
    </>
  );
};

export default CrashGameDetail;
